import React from "react";
import cn from "classnames";

const SmallInput = (props) => {
  const {
    type,
    label,
    hideLabel,
    value,
    name,
    onChange,
    disabled,
    required,
    placeholder,
    onClick,
    red_bg,
    yellow_bg,
  } = props;

  return (
    <div>
      <label htmlFor={name} className={hideLabel ? "sr-only" : ""}>
        {label}
      </label>
      <input
        id={name}
        type={type}
        value={value ?? ""}
        name={name}
        onChange={onChange}
        onClick={onClick}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        className={cn("w-10 h-9 px-1 bg-transparent rounded-md text-center", {
          "border border-gray-300": !disabled,
          "bg-red-300": (disabled && value < 0) || (red_bg && value < 0),
          "bg-yellow-200": yellow_bg,
        })}
      />
    </div>
  );
};

export default SmallInput;
